export const OPTIONS = [{label:'dropdown_language.fr.option',value:'fr'},{label:'dropdown_language.en.option',value:'en'},{label:'dropdown_language.nl.option',value:'nl'}]
